var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M0 17.281h45.587v6.512H0zM0 0h45.587v6.512H0z"
  })));
}

export default SvgLedEqual;